exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputW_3906bbd{width:400px!important}.inputQRCode_0ff25a5{width:100px!important}.ueditorW_de83da3{width:800px!important}", ""]);

// exports
exports.locals = {
	"inputW": "inputW_3906bbd",
	"inputQRCode": "inputQRCode_0ff25a5",
	"ueditorW": "ueditorW_de83da3"
};